import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Reassign Candidate|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPToolsReassignCandidate';
export type SPToolsReassignCandidateLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleIdentities`
	| `${LocNameStart}LabelLosingCandidate`
	| `${LocNameStart}LabelWinningCandidate`
	| `${LocNameStart}TitleExams`
	| `${LocNameStart}TitleCReqs`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ButtonChangeCandidates`
	| `${LocNameStart}ButtonConfirm`
	| `${LocNameStart}NotificationSuccess`
	| `${LocNameStart}NotificationNoChanges`;

export const spToolsReassignCandidateLocs: LocDefs<SPToolsReassignCandidateLocNames> = {
	SPToolsReassignCandidateTitleTab: {
		defaultValue: 'Review | Reassign Candidate Data',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Core/Tools.ReassignCandidateData.Title.ReviewTabTitle',
		...sharedProperties,
	},
	SPToolsReassignCandidateTitleIdentities: {
		defaultValue: 'Candidate Identities',
		description: 'Title for the identities section',
		displayPath: `${pathStart}Identities Title`,
		displayType: 'Title',
		legacyName: 'Core/Tools.ReassignCandidateData.Title.IdentitySection',
		...sharedProperties,
	},
	SPToolsReassignCandidateLabelLosingCandidate: {
		defaultValue: 'Losing Candidate',
		description: 'Label for the losing candidate',
		displayPath: `${pathStart}Losing Candidate Label`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.Label.LosingCandidateLabel',
		...sharedProperties,
	},
	SPToolsReassignCandidateLabelWinningCandidate: {
		defaultValue: 'Winning Candidate',
		description: 'Label for the winning candidate',
		displayPath: `${pathStart}Winning Candidate Label`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.Label.WinningCandidateLabel',
		...sharedProperties,
	},
	SPToolsReassignCandidateTitleExams: {
		defaultValue: 'Exams',
		description: 'Title for the exams section',
		displayPath: `${pathStart}Exams Title`,
		displayType: 'Title',
		legacyName: 'Core/Tools.ReassignCandidateData.Title.ExamSection',
		...sharedProperties,
	},
	SPToolsReassignCandidateTitleCReqs: {
		defaultValue: 'Other Requirements',
		description: 'Title for the other requirements section',
		displayPath: `${pathStart}CReqs Title`,
		displayType: 'Title',
		legacyName: 'Core/Tools.ReassignCandidateData.Title.CReqSection',
		...sharedProperties,
	},
	SPToolsReassignCandidateLabelComments: {
		defaultValue: 'Comments',
		description: 'Label for the comments field',
		displayPath: `${pathStart}Comments Label`,
		displayType: 'Label',
		legacyName: 'Core/Tools.ReassignCandidateData.FieldLabel.Comments',
		...sharedProperties,
	},
	SPToolsReassignCandidateButtonChangeCandidates: {
		defaultValue: 'Change Candidates',
		description: 'Button to change candidates',
		displayPath: `${pathStart}Change Candidates Button`,
		displayType: 'Button',
		legacyName: 'Core/Tools.ReassignCandidateData.Button.ChangeCandidates',
		...sharedProperties,
	},
	SPToolsReassignCandidateButtonConfirm: {
		defaultValue: 'Reassign Selected Data',
		description: 'Button to confirm reassign',
		displayPath: `${pathStart}Confirm Button`,
		displayType: 'Button',
		legacyName: 'Core/Tools.ReassignCandidateData.Button.Confirm',
		...sharedProperties,
	},
	SPToolsReassignCandidateNotificationSuccess: {
		defaultValue: 'Data successfully reassigned',
		description: 'Success message for data reassignment',
		displayPath: `${pathStart}Success`,
		displayType: 'Notification',
		legacyName: 'Core/Tools.ReassignCandidateData.NotificationMessage.Success',
		...sharedProperties,
	},
	SPToolsReassignCandidateNotificationNoChanges: {
		defaultValue: 'You must select at least one change',
		description: 'Error message when no changes are selected',
		displayPath: `${pathStart}No Changes`,
		displayType: 'Notification',
		legacyName: 'Core/Tools.ReassignCandidateData.NotificationMessage.NoChanges',
		...sharedProperties,
	},
};

export type SPToolsReassignCandidateLocType = LocMap<SPToolsReassignCandidateLocNames>;
